<template>
    <div
        v-if="apiToken && jobTitle"
        class="af-apply-with-option af-apply-with-indeed"
    >
        <div
            class="af-apply-with-item afu-p-5 afu-flex afu-items-center afu-justify-center afu-shadow-lg afu-rounded-btn afu-bg-white afu-cursor-pointer afu-border afu-border-solid afu-border-transparent hover:afu-border-solid hover:afu-border hover:afu-border-secondary-light"
        >
            <span
                class="indeed-apply-widget"
                :data-indeed-apply-jobid="jobUuid"
                :data-indeed-apply-apitoken="apiToken"
                :data-indeed-apply-email="encrypedEmail"
                :data-indeed-apply-jobcompanyName="companyName"
                :data-indeed-apply-joblocation="location"
                :data-indeed-apply-jobtitle="jobTitle"
                data-indeed-apply-jobmeta="right-rail-apply-button"
            >
                Indeed  
            </span>
        </div>
    </div>
</template>

<script>
    import ApplyWithMixin from './ApplyWithMixin';
    import { mapState } from 'vuex';

    export default {
        name: 'Indeed',

        mixins: [ApplyWithMixin], 

        data() {
            return {
                jobUuid: '',
                job: {},
                apiToken: window.afConfig?.indeed_api_token || null,
                encrypedEmail: window.afConfig?.indeed_encryped_email || null,
                loaded: false,
            };
        },

        created() {
            this.jobUuid = this.$route.params.uuid;
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
            }),

            location() {
                return this.$_job?.location_label || '';
            },

            jobTitle() {
                return this.$_job?.job_title || '';
            },

            companyName() {
                return this.$_job?.company_name || '';
            },
        },

        mounted() {
            const script = document.createElement('script');
            script.setAttribute('id', 'indeed-apply-js');
            script.setAttribute('async', true);
            script.setAttribute('src', 'https://apply.indeed.com/indeedapply/static/scripts/app/bootstrap.js');
            document.head.appendChild(script);
        },
    };
</script>

